import { Link } from 'react-router-dom'
import { useCartStore } from '@store/useCartStore'
import { useToastStore } from '@store/useToastStore'
import './ProductCard.scss'

const BG_GRADIENTS = [
  'linear-gradient(135deg, var(--tan) 0%, var(--cream) 100%)',
  'linear-gradient(135deg, #EAD9C8, #F8F3ED)',
  'linear-gradient(135deg, #E8E0D8, #F5EEE6)',
]

function SachetVisual() {
  return (
    <div className="sachet-visual">
      <div className="sachet-ribbon" />
      <div className="petal" />
      <div className="petal" />
      <div className="petal" />
      <div className="mini-leaf" />
      <div className="mini-leaf" />
    </div>
  )
}

function HexVisual() {
  return (
    <div className="hex-visual">
      <div className="petal" />
      <div className="petal" />
    </div>
  )
}

function BurnerVisual() {
  return (
    <div className="burner-visual">
      <div className="burner-top" />
      <div className="melt-chunk c1" />
      <div className="melt-chunk c2" />
      <div className="melt-chunk c3" />
      <div className="burner-arch" />
    </div>
  )
}

const VISUALS = { sachet: SachetVisual, hex: HexVisual, burner: BurnerVisual }

export default function ProductCard({ product, visualType = 'sachet', bgGradient, index = 0 }) {
  const addItem = useCartStore((s) => s.addItem)
  const addToast = useToastStore((s) => s.addToast)
  const Visual = VISUALS[visualType] || SachetVisual
  const gradient = bgGradient || BG_GRADIENTS[index % BG_GRADIENTS.length]
  const hasImage = product.main_image && product.main_image.trim()

  const handleAdd = (e) => {
    e.preventDefault()
    addItem(product, null, 1)
    addToast({ message: `${product.name} adăugat în coș`, type: 'success' })
  }

  return (
    <div className="shop-prod-card">
      <Link to={`/product/${product.slug}`} className="shop-prod-img">
        <div className="shop-prod-img-bg" style={{ background: gradient }} />
        {hasImage ? (
          <img src={product.main_image} alt={product.name} className="shop-prod-photo" />
        ) : (
          <div className="shop-prod-visual">
            <Visual />
          </div>
        )}
      </Link>
      <div className="shop-prod-info">
        <div className="shop-prod-tag">
          {product.short_description || 'Produs'}
        </div>
        <div className="shop-prod-name">{product.name}</div>
        <p className="shop-prod-desc">
          {product.description?.slice(0, 120)}
          {product.description?.length > 120 ? '…' : ''}
        </p>
        <div className="shop-prod-footer">
          <span className="shop-prod-price">
            {product.compare_price != null && Number(product.compare_price) > Number(product.price) && (
              <span className="shop-prod-compare">{product.compare_price} lei</span>
            )}
            {product.price} lei
          </span>
          <button type="button" className="shop-prod-btn" onClick={handleAdd}>
            Adaugă
          </button>
        </div>
      </div>
    </div>
  )
}
